import { OverallValidationResult, validator } from '../../../tradebuilder-v2/util'
import { EditAssetsState } from '../edit-asset-slice'
import { editAssetRules } from './edit-asset'

const editAssetValidator = validator(editAssetRules)

export function validate(assetState: EditAssetsState): OverallValidationResult {
  return editAssetValidator(assetState)
}
